/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.19.0
 * @since 1.19.0
 */

import { useMemo } from 'react';

import { useSelector } from 'react-redux';

import { tableMetaExportSelector, tableMetaUrlSelector } from '../../selectors';

export const useTableExport = () => {

    const metaUrl = useSelector(tableMetaUrlSelector);

    const optionsSelector = useMemo(() => tableMetaExportSelector(metaUrl), [metaUrl]);
    const options = useSelector(optionsSelector);

    return { options };
}
